module.exports = __webpack_public_path__ + "d5b9d3c081ec87f5531dbd43e0a20da9.pdf";